import { rootApi } from "../user/api";

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ["SummaryAlLocation"],
});

export const summaryAlLocationApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findSummaryAlLocationOverall: builder.query({
      query: () => `/summary-allocation/overall/`,
      providesTags: ["SummaryAlLocation"],
    }),
    findSummaryAlLocationCompany: builder.query({
      query: () => `summary-allocation/company/`,
      providesTags: ["SummaryAlLocation"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindSummaryAlLocationOverallQuery,
  useFindSummaryAlLocationCompanyQuery,
} = summaryAlLocationApi;
